import { TermsAndConditionsModel } from "src/app/models/common/terms-and-conditions.model";
import { IInsurance } from "../../../models/common/insurance";

export interface IOneWayQuoteModel {
  id?: string;
  lead: string;
  pickup_charge: number;
  pickup_charge_currency: string;
  payee: string;
  min_per_diem: number;
  min_per_diem_currency: string;
  max_per_diem: number;
  max_per_diem_currency: string;
  dpp_charge: number;
  dpp_charge_currency: string;
  storage_charge: number;
  storage_charge_currency: string;
  dropoff_charge: number;
  dropoff_charge_currency: string;
  cancellation_charge: number;
  cancellation_charge_currency: string;
  drv_new_build_price: number;
  drv_new_build_price_currency: string;
  min_late_charge: number;
  min_late_charge_currency: string;
  max_late_charge: number;
  max_late_charge_currency: string;
  drv_depreciation_per_year: number;
  min_replacement_value: number;
  min_free_days: number;
  max_free_days: number;
  remarks: string;
  request_number?: string;
  insurance: string | IInsurance;
  quantity: number;
  drv_max_depreciation_percent: number;
  quote_valid_till: Date;
  terms_and_condition_fk: string | TermsAndConditionsModel;
  terms_and_condition_text: string;
}

export interface IOneWayQuoteError {
  pickup_charge: string[];
  pickup_charge_currency: string[];
  payee: string[];
  min_per_diem: string[];
  min_per_diem_currency: string[];
  max_per_diem: string[];
  max_per_diem_currency: string[];
  dpp_charge: string[];
  dpp_charge_currency: string[];
  storage_charge: string[];
  storage_charge_currency: string[];
  dropoff_charge: string[];
  dropoff_charge_currency: string[];
  cancellation_charge: string[];
  cancellation_charge_currency: string[];
  drv_new_build_price: string[];
  drv_new_build_price_currency: string[];
  min_late_charge: string[];
  min_late_charge_currency: string[];
  max_late_charge: string[];
  max_late_charge_currency: string[];
  drv_depreciation_per_year: string[];
  min_replacement_value: string[];
  min_free_days: string[];
  max_free_days: string[];
  remarks: string[];
  insurance: string[];
  drv_max_depreciation_percent: string[];
  quote_valid_till: string[];
  terms_and_condition_fk: string[];
  terms_and_condition_text: string[];
}

export class OneWayQuoteModel {
  id?: string;
  lead: string;
  pickup_charge: number;
  pickup_charge_currency: string;
  payee: string;
  min_per_diem: number;
  min_per_diem_currency: string;
  max_per_diem: number;
  max_per_diem_currency: string;
  dpp_charge: number;
  dpp_charge_currency: string;
  storage_charge: number;
  storage_charge_currency: string;
  dropoff_charge: number;
  dropoff_charge_currency: string;
  cancellation_charge: number;
  cancellation_charge_currency: string;
  drv_new_build_price: number;
  drv_new_build_price_currency: string;
  min_late_charge: number;
  min_late_charge_currency: string;
  max_late_charge: number;
  max_late_charge_currency: string;
  drv_depreciation_per_year: number;
  min_replacement_value: number;
  min_free_days: number;
  max_free_days: number;
  remarks: string;
  request_number: string;
  insurance: string | IInsurance;
  quantity: number;
  drv_max_depreciation_percent: number;
  quote_valid_till: Date;
  terms_and_condition_fk: string | TermsAndConditionsModel;
  terms_and_condition_text: string;

  error: IOneWayQuoteError;

  validations = {}

  constructor(lead: string) {
    this.id = null;
    this.lead = lead;
    this.pickup_charge = null;
    this.pickup_charge_currency = 'USD';
    this.payee = null;
    this.min_per_diem = null;
    this.min_per_diem_currency = 'USD';
    this.max_per_diem = null;
    this.max_per_diem_currency = 'USD';
    this.dpp_charge = null;
    this.dpp_charge_currency = 'USD';
    this.storage_charge = null;
    this.storage_charge_currency = 'USD';
    this.dropoff_charge = null;
    this.dropoff_charge_currency = 'USD';
    this.cancellation_charge = null;
    this.cancellation_charge_currency = 'USD';
    this.drv_new_build_price = null;
    this.drv_new_build_price_currency = 'USD';
    this.min_late_charge = null;
    this.min_late_charge_currency = 'USD';
    this.max_late_charge = null;
    this.max_late_charge_currency = 'USD';
    this.drv_depreciation_per_year = null;
    this.min_replacement_value = null;
    this.min_free_days = null;
    this.max_free_days = null;
    this.remarks = null;
    this.request_number = null;
    this.insurance = null;
    this.quantity = null;
    this.drv_max_depreciation_percent = null;
    let quote_valid_till = new Date();
    quote_valid_till.setDate(quote_valid_till.getDate() + 21);
    this.quote_valid_till = quote_valid_till;
    this.terms_and_condition_fk = null;
    this.terms_and_condition_text = null;

    this.resetErrors();
  }

  resetErrors() {
    this.error = {
      pickup_charge: [],
      pickup_charge_currency: [],
      payee: [],
      min_per_diem: [],
      min_per_diem_currency: [],
      max_per_diem: [],
      max_per_diem_currency: [],
      dpp_charge: [],
      dpp_charge_currency: [],
      storage_charge: [],
      storage_charge_currency: [],
      dropoff_charge: [],
      dropoff_charge_currency: [],
      cancellation_charge: [],
      cancellation_charge_currency: [],
      drv_new_build_price: [],
      drv_new_build_price_currency: [],
      min_late_charge: [],
      min_late_charge_currency: [],
      max_late_charge: [],
      max_late_charge_currency: [],
      drv_depreciation_per_year: [],
      min_replacement_value: [],
      min_free_days: [],
      max_free_days: [],
      remarks: [],
      insurance: [],
      drv_max_depreciation_percent: [],
      quote_valid_till: [],
      terms_and_condition_fk: [],
      terms_and_condition_text: [],
    }
  }

  is_valid() {
    this.resetErrors();

    if (this.quote_valid_till == null) {
      this.error.quote_valid_till.push('Please select quotation validity date');
    }
    if (this.pickup_charge == null) {
      this.error.pickup_charge.push('Pick-up charge is required');
    }
    if (this.payee == null) {
      this.error.payee.push('Please select a payee');
    }
    if (this.min_free_days == null) {
      this.error.min_free_days.push('Free days is required');
    }
    if (this.min_per_diem == null) {
      this.error.min_per_diem.push('Per Diem charge is required');
    }
    if (this.dpp_charge == null) {
      this.error.dpp_charge.push('DPP charge is required');
    }
    if (this.storage_charge == null) {
      this.error.storage_charge.push('Storage charge is required');
    }
    if (this.cancellation_charge == null) {
      this.error.cancellation_charge.push('Cancellation charge is required');
    }
    if (this.drv_new_build_price == null) {
      this.error.drv_new_build_price.push('New Build price is required');
    }
    if (this.drv_depreciation_per_year == null) {
      this.error.drv_depreciation_per_year = ['Depreciation charge is required'];
    }
    if (this.drv_max_depreciation_percent == null) {
      this.error.drv_max_depreciation_percent = ['Max Depreciation charge is required'];
    }
    if (this.insurance == null) {
      this.error.insurance = ['Please select an insurance'];
    }

    return this.error.pickup_charge.length == 0 &&
      this.error.payee.length == 0 &&
      this.error.min_free_days.length == 0 &&
      this.error.min_per_diem.length == 0 &&
      this.error.dpp_charge.length == 0 &&
      this.error.storage_charge.length == 0 &&
      this.error.cancellation_charge.length == 0 &&
      this.error.drv_new_build_price.length == 0 &&
      this.error.drv_depreciation_per_year.length == 0 &&
      this.error.drv_max_depreciation_percent.length == 0 &&
      this.error.insurance.length == 0 &&
      this.error.quote_valid_till.length == 0
  }

  getSavePayload(): IOneWayQuoteModel {
    return {
      lead: this.lead,
      pickup_charge: this.pickup_charge,
      pickup_charge_currency: this.pickup_charge_currency,
      payee: this.payee,
      min_per_diem: this.min_per_diem,
      min_per_diem_currency: this.min_per_diem_currency,
      max_per_diem: this.max_per_diem,
      max_per_diem_currency: this.max_per_diem_currency,
      dpp_charge: this.dpp_charge,
      dpp_charge_currency: this.dpp_charge_currency,
      storage_charge: this.storage_charge,
      storage_charge_currency: this.storage_charge_currency,
      dropoff_charge: this.dropoff_charge,
      dropoff_charge_currency: this.dropoff_charge_currency,
      cancellation_charge: this.cancellation_charge,
      cancellation_charge_currency: this.cancellation_charge_currency,
      drv_new_build_price: this.drv_new_build_price,
      drv_new_build_price_currency: this.drv_new_build_price_currency,
      min_late_charge: this.min_late_charge,
      min_late_charge_currency: this.min_late_charge_currency,
      max_late_charge: this.max_late_charge,
      max_late_charge_currency: this.max_late_charge_currency,
      drv_depreciation_per_year: this.drv_depreciation_per_year,
      min_replacement_value: this.min_replacement_value,
      min_free_days: this.min_free_days,
      max_free_days: this.max_free_days,
      remarks: this.remarks,
      insurance: typeof this.insurance == 'object' && this.insurance != null ? this.insurance.id : this.insurance,
      quantity: this.quantity,
      drv_max_depreciation_percent: this.drv_max_depreciation_percent,
      quote_valid_till: this.quote_valid_till,
      terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
      terms_and_condition_text: this.terms_and_condition_text,
    }
  }

  savePayloadToModel(payload: IOneWayQuoteModel) {
    this.id = payload.id;
    this.lead = payload.lead;
    this.pickup_charge = payload.pickup_charge;
    this.pickup_charge_currency = payload.pickup_charge_currency;
    this.payee = payload.payee;
    this.dpp_charge = payload.dpp_charge;
    this.dpp_charge_currency = payload.dpp_charge_currency;
    this.storage_charge = payload.storage_charge;
    this.storage_charge_currency = payload.storage_charge_currency;
    this.dropoff_charge = payload.dropoff_charge;
    this.dropoff_charge_currency = payload.dropoff_charge_currency;
    this.cancellation_charge = payload.cancellation_charge;
    this.cancellation_charge_currency = payload.cancellation_charge_currency;
    this.drv_new_build_price = payload.drv_new_build_price;
    this.drv_new_build_price_currency = payload.drv_new_build_price_currency;
    this.min_late_charge = payload.min_late_charge;
    this.min_late_charge_currency = payload.min_late_charge_currency;
    this.max_late_charge = payload.max_late_charge;
    this.max_late_charge_currency = payload.max_late_charge_currency;
    this.drv_depreciation_per_year = payload.drv_depreciation_per_year;
    this.min_replacement_value = payload.min_replacement_value;
    this.min_free_days = payload.min_free_days;
    this.max_free_days = payload.max_free_days;
    this.remarks = payload.remarks;
    this.request_number = payload.request_number;
    this.insurance = payload.insurance;
    this.quote_valid_till = payload.quote_valid_till;
    this.terms_and_condition_fk = payload.terms_and_condition_fk;
    this.terms_and_condition_text = payload.terms_and_condition_text;
  }
}
